import { ANSWER_TYPE_SINGLE, POLL_STATUS_DRAFT } from "../Constants/constantValues";

export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const normalizeText = (text) => {
  return (text || "").trim();
};

export const isPollModified = (currentPoll, originalPoll, QUESTION_MIN_LENGTH, MIN_OPTIONS) => {
  if (!currentPoll) return false;

  if (String(currentPoll.id).startsWith("temp-")) {
    if (!originalPoll) {
      const hasQuestion = normalizeText(currentPoll.question_text).length >= QUESTION_MIN_LENGTH;
      const validOptions = currentPoll.options.filter(
        opt => normalizeText(opt.option_text).length > 0
      );
      return hasQuestion && validOptions.length >= MIN_OPTIONS;
    }
  }

  if (!originalPoll) return true;

  if (normalizeText(currentPoll.question_text) !== normalizeText(originalPoll.question_text)) {
    return true;
  }

  if (currentPoll.answer_type !== originalPoll.answer_type) {
    return true;
  }

  if (currentPoll.options.length !== originalPoll.options.length) {
    return true;
  }

  for (const currentOpt of currentPoll.options) {
    const originalOpt = originalPoll.options.find(o => o.id === currentOpt.id);
    
    if (!originalOpt) return true;
    
    if (normalizeText(currentOpt.option_text) !== normalizeText(originalOpt.option_text)) {
      return true;
    }
  }

  return false;
};

export const createEmptyPoll = () => {
  const timestamp = Date.now();
  return {
    id: `temp-${timestamp}`,
    question_text: "",
    answer_type: ANSWER_TYPE_SINGLE,
    status: POLL_STATUS_DRAFT,
    options: [
      { id: `temp-opt-${timestamp}-1`, option_text: "", position: 0 },
      { id: `temp-opt-${timestamp}-2`, option_text: "", position: 1 },
    ],
    _isNew: true,
  };
};

export const validatePoll = (poll, QUESTION_MIN_LENGTH, MIN_OPTIONS, t) => {
  const errors = {};
  
  if (!poll.question_text || normalizeText(poll.question_text).length < QUESTION_MIN_LENGTH) {
    errors.question = t("conferences.question_text_required");
  }

  poll.options.forEach((opt) => {
    if (normalizeText(opt.option_text).length === 0) {
      errors[opt.id] = t("conferences.enter_option");
    }
  });

  const validOptions = poll.options.filter(
    (opt) => normalizeText(opt.option_text).length > 0
  );

  if (validOptions.length < MIN_OPTIONS) {
    poll.options.forEach((opt) => {
      if (normalizeText(opt.option_text).length === 0) {
        errors[opt.id] = t("conferences.enter_option");
      }
    });
  }

  return errors;
};

export const isTempPoll = (pollId) => {
  return String(pollId).startsWith("temp-");
};

export const isTempOption = (optionId) => {
  return String(optionId).startsWith("temp-");
};

export const createEmptyOption = () => {
  return {
    id: `temp-opt-${Date.now()}`,
    option_text: "",
    position: 0,
    _isNew: true,
  };
};